import * as R from 'ramda';
import * as actionTypes from '../actionTypes';

const state = {
  isLoadingGetProfile: false,
  getProfileMessage: '',
  getProfileFailed: '',

  isLoadingUpdateProfile: false,
  updateProfileMessage: '',
  updateProfileFailed: '',
};

const initialState = R.clone(state);

function profileReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.INITIALIZE_STATES_FULFILLED:
      return {
        ...initialState,
      };
    case actionTypes.GET_PROFILE_PENDING:
      return {
        ...globalState,
        isLoadingGetProfile: true,
      };
    case actionTypes.GET_PROFILE_FULFILLED:
      return {
        ...globalState,
        isLoadingGetProfile: false,
        getProfileMessage: action.data,
        getProfileFailed: '',
      };
    case actionTypes.GET_PROFILE_FAILURE:
      return {
        ...globalState,
        isLoadingGetProfile: false,
        getProfileFailed: action.error,
        getProfileMessage: '',
      };
    case actionTypes.UPDATE_PROFILE_PENDING:
      return {
        ...globalState,
        isLoadingUpdateProfile: true,
      };
    case actionTypes.UPDATE_PROFILE_FULFILLED:
      return {
        ...globalState,
        isLoadingUpdateProfile: false,
        updateProfileMessage: action.data,
        updateProfileFailed: '',
      };
    case actionTypes.UPDATE_PROFILE_FAILURE:
      return {
        ...globalState,
        isLoadingUpdateProfile: false,
        updateProfileMessage: '',
        updateProfileFailed: action.error,
      };
    default:
      return globalState;
  }
}

export { profileReducer as default };
